<template>
  <button
    class="button -secondary mt-2 mb-2"
    id="mikmak-button"
    :data-mm-ids="productId"
    :data-mm-wtbid="mikmakWidgetId"
    :data-mm-sticky="mikmakStickyButton"
    v-bind="additionalProp"
    :aria-label="labelText"
  >
    {{ labelText }}
  </button>
</template>

<script>
import { AnalyticsHandler } from '../../scripts/directives/analyticsHandler/AnalyticsHandler';

export default {
  name: 'MikMakButton',
  props: {
    mikmakWidgetId: {
      type: String,
      required: false,
    },
    mikmakStickyButton: {
      type: Boolean,
      required: false,
    },
    labelText: {
      type: String,
      default: 'BUY NOW',
    },
    productId: {
      type: String,
      required: false,
    },
    pageCategory: {
      type: String,
      default: '',
    },
  },
  computed: {
    additionalProp() {
      return this.mikmakStickyButton
        ? { 'data-mm-main-id': this.productId }
        : {};
    },
  },
  mounted() {
    if (!window.swnDataLayer) window.swnDataLayer = {};
    window.swnDataLayer.widget_callback = this.handleMikMakEvents;
  },
  methods: {
    handleMikMakEvents(event) {
      if (event.action === 'clk') this.triggerAnalytics(event, 'buy_now');
      if (event.action === 'buy') this.addToCart(event, 'add_to_cart');
      if (event.action === 'close')
        this.triggerAnalytics(event, 'close_eretail_popup');
    },
    addToCart(event, eventName) {
      try {
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'addToCart',
          event: 'addToCart',
          ename: eventName,
          category: 'Ecommerce',
          action: `${this.pageCategory}::redirection::${event.store.name}`,
          label: `${event.product.name}::${event.product.ean}`,
          productInfo: `${event.product.name}::${event.product.ean}`,
          step: 'redirection',
          storeName: event.store.name,
          ecommerce: {
            currencyCode: event.product.currency,
            add: {
              products: [
                {
                  name: event.product.name,
                  id: event.product.ean,
                  price: event.product.price,
                  brand: event.product.brand,
                  category: event.product.categoryName,
                  dimension48: event.product.ean,
                  dimension50: 'none',
                },
              ],
            },
          },
        });
      } catch (error) {
        console.error(error);
      }
    },
    triggerAnalytics(event, eventName) {
      try {
        AnalyticsHandler.getAnalyticsHandler().push({
          type: 'userActionEvent',
          event_name: eventName,
          ecommerce: 'undefined',
          category: 'Ecommerce',
          action: eventName,
          label: `${event.product.name}::${event.product.ean}`,
          product_info: `${event.product.name}::${event.product.ean}`,
        });
      } catch (error) {
        console.error(error);
      }
    },
  },
};
</script>
